import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HomeResponse } from './home.model';
import { BaseHttpResponse } from '../_common/models/core.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class HomeService {
  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
  ) { }

  getChanges(): Observable<HomeResponse> {
    return this.http.get<BaseHttpResponse<string>>(this.apiUrl + 'home/changes');
  }
}

